import React, { useMemo } from 'react';
import { DropzoneRootProps, DropzoneState } from 'react-dropzone';
import styled from 'styled-components';
import Portal from '@/components/portal';

export interface FileDropzoneProps extends DropzoneState {
  overlayVisible?: boolean;
}

export function FileDropzone({
  overlayVisible,
  isFocused,
  isDragAccept,
  isDragReject,
  getRootProps,
  getInputProps,
}: FileDropzoneProps) {
  const style: DropzoneRootProps = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  if (!overlayVisible) return null;

  return (
    <Portal selector="body">
      <DropzoneWrapper id="drop-zone-wrapper" {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <span>Drop files here to add it to the conversation</span>
      </DropzoneWrapper>
    </Portal>
  );
}

const DropzoneWrapper = styled.div`
  position: fixed;
  z-index: 1000000000000;
  height: 100%;
  width: 100%;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    color: #373737;
    font-size: 1.8rem;
    font-weight: 500;
    text-align: center;
    padding: 10px;
    font-family: Eesti, sans-serif;
  }
`;

const baseStyle = {
  backgroundColor: `rgba(33, 174, 234, 0.2)`,
  backdropFilter: `blur(8px)`,
};

const focusedStyle = {
  backgroundColor: `rgba(0, 0, 0, 0.1)`,
};

const acceptStyle = {};

const rejectStyle = {
  backgroundColor: `rgba(33, 174, 234, 0.2)`,
};
